import { listPage } from '@/services/home';
import { useRequest } from '@umijs/max';
import { useEffect } from 'react';

export default function useHome() {
  // 首页
  const { data: dataPageHome, run: runPageHome } = useRequest(listPage, {
    manual: true,
  });

  // 集团概览等所有页面
  const { data: dataPageAll, run: runPageAll } = useRequest(listPage, {
    manual: true,
  });

  // 集团概览等所有页面
  const { data: dataPageMobile, run: runPageAllMobile } = useRequest(listPage, {
    manual: true,
  });

  useEffect(() => {
    // pc首页-82  pc集团概览1
    runPageHome({
      categoryId: 82,
      showPlat: 1,
    });

    // pc集团概览1
    runPageAll({
      showPlat: 1,
    });

    runPageAllMobile({
      showPlat: 2,
    });
  }, []);

  return {
    dataPageHome: dataPageHome?.resData,
    dataPageAll: dataPageAll?.resData?.groupToMap((item) => item?.categoryId),
    dataPageMobile: dataPageMobile?.resData?.groupToMap(
      (item) => item?.categoryId,
    ),
  };
}
